import { PERMISSION_SCOPES, PermissionScope } from "@/modules/auth/types";

/**
 * Who may open the Onboarding view. Shared by the route guard in `App.tsx` and
 * the navigation entry so the two cannot drift apart. The backend enforces the
 * same scopes on the lead routes; this only decides what the UI offers.
 */
export const ONBOARDING_PERMISSION_SCOPES: PermissionScope[] = [
  PERMISSION_SCOPES.ADMIN,
  PERMISSION_SCOPES.TAX_SUPERVISOR,
  PERMISSION_SCOPES.CLERK,
];
